import { arrayContains } from 'utils';
import { SEND_CANCELLATION_FAILURE } from 'redux/actions';

export const isCancellationFailed = (state) => arrayContains(state.entities.users.failedRequests, [SEND_CANCELLATION_FAILURE]);
